// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2YX82","colBig":"styles_colBig__37PHF","colSmall":"styles_colSmall__13cLj"};